export default __webpack_public_path__ + "ea4a2479a9cc0b778d24300fa8f20b48.svg";